<template>
  <div class="teacher-tag">
    {{ teacher.name }}
  </div>
</template>

<script>
export default {
  props: {
    teacher: Object,
  },
  computed: {
    teacherId() {
      if (this.teacher.id !== ``) {
        return this.teacher.id;
      }
      return 1;
    },
  },
};
</script>

<style lang="scss">
.teacher-tag {
  display: inline-block;
  color: #000000;
}
</style>
